import React from 'react';
import {Link} from 'react-router';
class RowItemSearchDonViSoNoiVu extends React.Component {

  chonDonVi() {
    this.props.onSelect(this.props.item);
  }

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{this.props.item.tenDonVi}</td>
        <td>{this.props.item.tenCapDonVi}</td>
        <td>{this.props.item.tenDonViCapTren}</td>
        <td className="action-center">
            <Link className="icon-check-file" onClick={this.chonDonVi.bind(this)}>Chọn</Link>
        </td>
      </tr>
    );
  }
}

export default RowItemSearchDonViSoNoiVu;


// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemSearchDonViSoNoiVu.jsx